<template>
  <v-container fluid>
    <v-row>
      <v-dialog
        v-model="successAddToCart"
        persistent
        max-width="450"
        max-height="350"
        width="100%"
      >
        <v-card>
          <v-card-title class="headline justify-center">
            <v-img
              max-height="44"
              max-width="42"
              src="@/assets/check-green.png"
            ></v-img>
          </v-card-title>
          <v-card-text class="text-center"
            >Produk sudah berhasil ditambah ke Keranjang</v-card-text
          >
          <v-card-text class="text-center">
            <v-spacer></v-spacer>
            <v-btn
              class="text-capitalize"
              small
              color="primary"
              elevation="0"
              @click="$router.back()"
            >
              Kembali
            </v-btn>
            <v-btn
              style="border-color: yellow"
              outlined
              class="text-capitalize ml-2"
              small
              text
              color="black"
              @click="toCart"
            >
              Lihat Keranjang
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-col cols="12" lg="6" md="6" sm="12">
        <v-card elevation="0" class="pa-4 rounded-xl product-gallery-card">

          <!-- MAIN CAROUSEL -->
          <v-carousel
            v-model="carouselIndex"
            hide-delimiter-background
            :show-arrows="productImages.length > 1"
            delimiter-icon="mdi-minus"
            height="500"
            class="product-carousel rounded-xl"
          >
            <v-carousel-item
              v-for="(img, index) in productImages"
              :key="index"
            >
              <div class="carousel-image-wrapper">
                <v-img
                  :src="img"
                  contain
                  class="main-product-image"
                  lazy-src="@/assets/empty-img.png"
                >
                  <template v-slot:placeholder>
                    <div class="d-flex align-center justify-center fill-height">
                      <v-progress-circular indeterminate />
                    </div>
                  </template>
                </v-img>
              </div>
            </v-carousel-item>
          </v-carousel>

          <!-- THUMBNAILS -->
          <div
            v-if="productImages.length > 1"
            class="thumbnail-wrapper mt-4"
          >
            <div
              v-for="(img, index) in productImages"
              :key="'thumb-' + index"
              class="thumbnail-item"
              :class="{ activeThumb: carouselIndex === index }"
              @click="carouselIndex = index"
            >
              <v-img
                :src="img"
                width="70"
                height="70"
                cover
                class="rounded-lg"
              />
            </div>
          </div>

        </v-card>
      </v-col>

      <!-- NON REWARD -->
      <v-col v-if="mode == $constant.NON_REWARD">
        <v-card elevation="0">
          <v-card-title class="">
            <div>
              <span
                v-if="
                  this.productDetails.totalDiscount != null &&
                    this.productDetails.totalDiscount != ''
                "
                style="
              color: black;
              font-size: 18px;
              font-weight: 800;
              line-height: 26px;
              text-decoration: line-through;
              "
              >
                <strong>
                  Rp. {{ humanFormat(this.productDetails.priceProduct) }}
                </strong>
              </span>
              <span
                v-if="
                  this.productDetails.totalDiscount != null &&
                    this.productDetails.totalDiscount != ''
                "
                style="
              color: crimson;
              font-size: 18px;
              font-weight: 800;
              line-height: 26px;
              "
              >
                <strong>
                  {{ this.productDetails.price }}
                </strong>
              </span>
              <span
                v-if="
                  this.productDetails.totalDiscount != null &&
                    this.productDetails.totalDiscount != ''
                "
                style="padding: 5px; background: pink; border-radius: 10px;"
              >
                {{ this.productDetails.totalDiscount }} Disc
              </span>
              <span
                style="
              color: black;
              font-size: 18px;
              font-weight: 800;
              line-height: 26px;
              "
                v-if="
                  this.productDetails.totalDiscount == null ||
                    this.productDetails.totalDiscount == ''
                "
              >
                Rp. {{ humanFormat(this.productDetails.priceProduct) }}
              </span>
              <br />
              <span
                style="
              color: black;
              font-size: 14px;
              font-weight: 600;
              line-height: 22px;
              "
              >
                <strong>
                  {{ this.productDetails.productName }}
                </strong>
              </span>
              <br />
              <span
                style="
              color: #3C3B3B;
              font-size: 12px;
              font-weight: 400;
              line-height: 20px;
              "
              >
                <strong>
                  {{ this.productDetails.productDesc }}
                </strong>
              </span>
            </div>
          </v-card-title>
          <v-card-subtitle>
            <div class="dtl-stock mt-2">
                <p class="text-center ma-0 pa-0"
                v-bind:class="getClass()">
                  {{ 
                    stok
                  }}
                </p>
              </div>
          </v-card-subtitle>
          <v-card-title>
            <v-btn
              class="text-capitalize rounded-lg"
              large
              block
              color="black"
              :disabled="disableBtnAdd"
              @click="addToCartItem()"
            >
              <span style="color: white;"> Masukkan Keranjang </span></v-btn
            >
          </v-card-title>
        </v-card>
      </v-col>

      <!-- REWARD PRODUK-->
      <v-col v-else>
        <v-card elevation="0">
          <v-card-title class="">
            <div>
                <div class="d-flex flex-row">
                    <v-img
                        max-height="30"
                        max-width="30"
                        src="@/assets/icon-color-coin.svg"
                    ></v-img>
                    <span class="ml-3 text-h5" style="color: #FFA800;">{{ this.productDetails.poin}} Poin</span>
                </div>
              <br />
              <span
                style="
              color: black;
              font-size: 14px;
              font-weight: 600;
              line-height: 22px;
              "
              >
                <strong>
                  {{ this.productDetails.productName }}
                </strong>
              </span>
              <br />
              <span
                style="
              color: #3C3B3B;
              font-size: 12px;
              font-weight: 400;
              line-height: 20px;
              "
              >
                <strong>
                  {{ this.productDetails.productDesc }}
                </strong>
              </span>

              <div class="dtl-stock mt-2">
                <p class="text-center ma-0 pa-0"
                v-bind:class="getClass()">
                  {{ 
                    stok
                  }}
                </p>
              </div>
            </div>
          </v-card-title>

          <v-card-title>
            <v-btn
              class="text-capitalize rounded-lg"
              large
              block
              color="black"
              :disabled="disableBtnAdd"
              @click="addToCartItemReward()"
            >
              <span style="color: white;"> Masukkan Keranjang </span></v-btn
            >
          </v-card-title>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import { mapActions,mapState } from "vuex";

export default {
    name: "ProductDtl",
    props: ['productCode','mode'],
    data() {
      return {
        product: null,
        quantity: 0,
        successAddToCart: false,

        selectedImage: "",
        carouselIndex: 0,
      };
    },
  methods: {
    ...mapActions(["changeTitleApp", "getProductByProductCode", "addToCart","getProductRewardByProductCode","addToCartReward"]),
    addQuantity() {
      this.quantity++;
    },
    removeQuantity() {
      if (this.quantity > 0) {
        this.quantity--;
      }
    },
    getClass(){
      return {
          'tersedia': this.productDetails.stok > 50,  
          'hampir-habis': this.productDetails.stok <= 50,
          'habis': this.productDetails.stok == 0 || this.productDetails.stok == null,
        }
    },

    clearQty() {
      this.quantity = 0;
    },

    toDashboard() {
      this.successAddToCart = false;
      this.$router.push(`/dashboard`);
    },
    toCart() {
      this.successAddToCart = false;
      if (this.mode == this.$constant.REWARD) {
        this.$router.push(`/cart/reward`);
      } else {
        this.$router.push(`/cart/nonreward`);
      }
    },

    async addToCartItem() {
      // console.log("masuk pak eko")
      await this.addToCart({
        price: this.productDetails.priceDecimal,
        productName: this.productDetails.productName,
        productCode: this.productDetails.productCode,
        productPartnerName: this.productDetails.productPartnerCode,
        genderCode: this.profile.genderCd,
        mobileNo: this.profile.mobileNo,
        personName: this.profile.personName,
        statusCode: "CIS_NEW",
        trxCode: this.productDetails.productCode,
      }).then((response) => {
        if (response.data.status == 1) {
          console.log("SUCCESS");
          this.successAddToCart = true;
        }
      });
    },

    async addToCartItemReward() {
      // console.log("masuk pak eko")
      await this.addToCartReward({
        price: this.productDetails.priceDecimal,
        poin: this.productDetails.poin,
        productName: this.productDetails.productName,
        productCode: this.productDetails.productCode,
        productPartnerName: this.productDetails.productPartnerCode,
        genderCode: this.profile.genderCd,
        mobileNo: this.profile.mobileNo,
        personName: this.profile.personName,
        statusCode: "CIS_NEW",
        trxCode: this.productDetails.productCode,
      }).then((response) => {
        if (response.data.status == 1) {
          console.log("SUCCESS");
          this.successAddToCart = true;
        }
      });
    },
  },

  created() {
    this.changeTitleApp("Detail Produk");
  },

  mounted() {
    if (this.mode == this.$constant.REWARD) {
        this.getProductRewardByProductCode({
        productCode: this.productCode,
        })
    } else {
        this.getProductByProductCode({
        productCode: this.productCode,
        })
    }
    
  },

  watch: {
  carouselIndex(val) {
    this.selectedImage = this.productImages[val];
  },
},

  computed: {
    ...mapState(["productDetails", "profile"]),

    productImages() {
      const images = [];

      /*
        PRODUCT IMAGE LIST
      */
      if (
        this.productDetails &&
        this.productDetails.productImageListList &&
        this.productDetails.productImageListList.length > 0
      ) {

        this.productDetails.productImageListList.forEach((item) => {

          if (item.imageFile) {
            images.push(
              `data:image/png;base64,${item.imageFile}`
            );
          }

        });
      }

      /*
        FALLBACK
      */
      if (
        images.length === 0 &&
        this.productDetails &&
        this.productDetails.iconSmall
      ) {
        images.push(
          `data:image/png;base64,${this.productDetails.iconSmall}`
        );
      }

      return images;
    },

    stok() {
      return this.productDetails.stok > 50
        ? 'Tersedia'
        : this.productDetails.stok <= 50 &&
          this.productDetails.stok > 0
        ? 'Hampir Habis'
        : this.productDetails.stok < 1 ||
          this.productDetails.stok == null
        ? 'Stok Habis'
        : ''
    },

    disableBtnAdd() {
      return (
        this.productDetails.stok < 1 ||
        this.productDetails.stok == null
      )
    }
  },
}
</script>

<style src="./ProductDtl.scss" lang="scss" />